<template>
  <div id="app" class="wrapper">
    <navigation-bar-component></navigation-bar-component>

    <transition name="fade">
      <router-view></router-view>
    </transition>

    <currency-switcher></currency-switcher>
    
    <footer-component></footer-component>
  </div>
</template>

<script>
  import NavigationBarComponent from "./views/partials/NavigationBarComponent"

  export default {
    components: {
      'navigation-bar-component': NavigationBarComponent
    },
    mounted() {
      window.jQuery('body').addClass('loaded');
    }
  };
</script>

<style lang="scss">

  // Fonts
  @import url('https://fonts.googleapis.com/css?family=Nunito');

  @import "~@fortawesome/fontawesome-free/css/all.css";

  // Variables
  @import './sass/variables';

  @import "./sass/mixins";

  // Bootstrap
  @import '~bootstrap/scss/bootstrap';

  @include font-face(ProximaRegular, sass/fonts/ProximaNova-Regular);

  @import "sass/app";
</style>
